import React from 'react';
import PageHeader from './global-components/page-header';
import Cat from './section-components/cat-life-style';

const CatLifeStyle = () => {
    return <div>
        <PageHeader headertitle="Life Style"  />
        <Cat />
    </div>
}

export default CatLifeStyle

